import { sharedCriteriaFields, sharedFeesFields } from './shared';

export const invoiceFinancingCriteria = [
  ...sharedCriteriaFields(),
  {
    columns: 12,
    fields: [
      {
        columns: 12,
        field: 'clientsType',
        optionsColumns: 3,
        type: 'multiple',
      },
    ],
    label: 'Business customers should be',
  },
  {
    fields: [
      {
        columns: 12,
        field: 'clientsJurisdiction',
        type: 'boolean',
      },
    ],
    label: 'Do you secure against receivables due from outside the uk?',
  },
  {
    fields: [
      {
        columns: 12,
        field: 'prePackProcedure',
        type: 'boolean',
      },
    ],
    label:
      'Do you consider businesses who have been through any administration/pre-pack procedure in the last 3 years.',
  },
  {
    fields: [
      {
        optionsColumns: 6,
        field: 'guarantees',
        type: 'multiple',
      },
    ],
    label: 'Required guarantees',
  },
  {
    fields: [
      {
        columns: 12,
        field: 'homeowner',
        type: 'boolean',
      },
    ],
    label: 'Do you require home ownership for personal guarantees?',
  },
  {
    columns: 12,
    fields: [
      {
        columns: 12,
        field: 'useOfFunds',
        optionsColumns: 4,
        type: 'multiple',
      },
    ],
    label: 'For what funding purposes is this product suitable?',
  },
];

export const invoiceFinancingFees = sharedFeesFields(true);
